import { readAppOrigin } from '../api/config'
import {
  type ReferenceImageUrlHints,
  resolveReferenceImageDisplayUrl,
  resolveStoredImageRemoteUrl,
} from './referenceImageUrl'

/**
 * 图库 from-remote / image-bytes 服务端代拉地址（不依赖 api client，避免与 resolvedMediaImage 循环引用）。
 */
export function resolveGalleryRemoteIngestUrl(raw: string, hints?: ReferenceImageUrlHints): string {
  const stored = resolveStoredImageRemoteUrl(raw).trim()
  if (!stored) return stored
  if (/^https?:\/\//i.test(stored)) return stored
  if (stored.startsWith('/')) {
    const origin = readAppOrigin().replace(/\/+$/, '')
    return origin ? `${origin}${stored}` : stored
  }
  const abs = resolveAbsoluteHttpImageUrl(raw, hints).trim()
  if (!/^https?:\/\//i.test(abs)) {
    throw new Error('当前图片地址无法在服务端拉取（仅支持 HTTP/HTTPS 外链）')
  }
  return abs
}

/** 服务端代拉：外链为库内绝对 http(s)；站内 /uploads 可相对或拼 API 源 */
export function resolveAbsoluteHttpImageUrl(raw: string, hints?: ReferenceImageUrlHints): string {
  const remote = resolveStoredImageRemoteUrl(raw)
  if (/^https?:\/\//i.test(remote)) return remote
  if (remote.startsWith('/')) {
    const origin = readAppOrigin().replace(/\/+$/, '')
    return origin ? `${origin}${remote}` : remote
  }
  const u = resolveReferenceImageDisplayUrl(raw, hints)
  if (!u) return u
  if (u.startsWith('/') && !u.startsWith('//')) {
    const origin = readAppOrigin().replace(/\/+$/, '')
    return `${origin}${u}`
  }
  return u
}
